import React from 'react';

import styled from '@emotion/styled';
import { mq, gray01, black02 } from '../../_style';

export default class Label extends React.Component {
  render() {
    const Container = styled.span`
      display: inline-block;
      padding: 5px 10px;
      ${mq.ie} {
        padding: 6px 10px 4px;
      }
      border-radius: 2px;
      background-color: ${gray01};
      color: ${black02};
      font-size: 10px;
      line-height: 1;
      ${mq.sp} {
        padding: 5px;
      }
    `;
    return <Container>{this.props.children}</Container>;
  }
}
